"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Graph = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const Base_1 = require("./Base");
const Graph = ({ colour = "#E6E6E6", size = 16, }) => (react_1.default.createElement(Base_1.Base, { size: size, stroke: colour },
    react_1.default.createElement("path", { fill: "none", d: "M15 14H1V2M2 12l5-7 2 4 3-5 2 2" })));
exports.Graph = Graph;
//# sourceMappingURL=Graph.js.map